import { Button, DatePicker, Form, Input, Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import svg66 from "../../../../assets/svg/svg66.svg";
import {
  fetchData,
  fetchPaymentModes,
  fetchSubwalletDropdown,
} from "../../../../features/fetch/fetchSlice";
import {
  clearObj,
  setActiveObj,
  setCategoryObj,
  setSinglePaymentObj,
  setSourceName,
} from "../../../../features/obj/objSlice";
import { useWatch } from "antd/es/form/Form";
import CategoryAdd from "../../../setup/category/modal/CategoryAdd";
import SubCategoryAdd from "../../../setup/sub-category/modal/SubCategoryAdd";
import { Navigate, useNavigate } from "react-router-dom";

const { TextArea } = Input;
export default function Step1({ handleNext, form }) {
  const dispatch = useDispatch();
  const navigate =  useNavigate()
  const { authLoading, authData } = useSelector((state) => state.auth);
  const { paymentGroups, subwalletData, dropLoading, paymentModes } =
    useSelector((state) => state.fetch);
  const { activeObj, categoryObj } = useSelector((state) => state.obj);
  const { user } = useSelector((state) => state.auth);
  const urlCat = "api/v1/payments/fetch-payment-categories";
  const urlSubCat = "api/v1/payments/fetch-sub-categories";

  const { loading, dataCat, dataSubCat } = useSelector((state) => ({
    loading: state.fetch.loading,
    dataCat: state.fetch.data[urlCat] || [],
    dataSubCat: state.fetch.data[urlSubCat] || [],
  }));
  const [paymentSourceName, setPaymentSourceName] = useState();
  const [paymentModeName, setPaymentModeName] = useState();
  const [categoryName, setCategoryName] = useState(categoryObj?.categoryName);
  const [subCategoryName, setSubCategoryName] = useState(
    categoryObj?.subCategoryName
  );

  const [openCategory, setopenCategory] = useState(false);
  function handleCancelCategory() {
    setopenCategory(false);
  }

  const [openSubCategory, setopenSubCategory] = useState(false);
  function handleCancelSubCategory() {
    setopenSubCategory(false);
  }

  useEffect(() => {
    setCategoryName(categoryObj?.categoryName || "");
    setSubCategoryName(categoryObj?.subCategoryName || "");
  }, [categoryObj]);
  async function handleSubmitStep() {
    const data = {};
    data.categoryName = categoryName;
    data.subCategoryName = subCategoryName;
    data.paymentModeName = paymentModeName;
    await dispatch(setCategoryObj(data));
    try {
      await form.validateFields(["pgId", "pgWalId", "pgReason"]);

      await handleNext();
    } catch {}
  }
  async function fetchSubWalletData() {
    dispatch(
      fetchSubwalletDropdown({
        url: `api/v1/wallet/sub/${user?.disbursementWalId}`,
      })
    );
  }
  async function fetchSubCategoryData(value) {
    dispatch(
      fetchData({
        url: urlSubCat,
        pcId: value,
      })
    );
  }
  useEffect(() => {
    dispatch(
      fetchData({
        url: urlCat,
        start: 0,
        limit: null,
      })
    );
    dispatch(
      fetchPaymentModes({
        url: "api/v1/payments/fetch-payment-modes",
      })
    );
  }, []);

  async function fetchSubCategoryData(value) {
    dispatch(
      fetchData({
        url: urlSubCat,
        pcId: value,
      })
    );
  }

  async function fetchCategoryData() {
    dispatch(
      fetchData({
        url: urlCat,
        start: 0,
        limit: null,
      })
    );
  }

  const pgPcId = useWatch("pgPcId", form);

  return (
    <>
      <div className="">
        <div className="flex flex-col mt-4 lg:px-10 px-3 ">
          <div className="text-[#353c48] text-[16px]">
            Please start by selecting the group you wish to make payment.
          </div>

          <div className="mt-10 ">
            <div className="grid lg:grid-cols-2 lg:gap-x-5 grid-cols-1">
              <Form.Item
                name="pgId"
                className=""
                label={"Group"}
                rules={[
                  {
                    required: true,
                    message: "Please select group",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    paymentGroups?.length > 0 &&
                    paymentGroups?.map((item) => ({
                      value: item?.pgId,
                      label: item?.pgName,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>

              <Form.Item
                name="pgWalId"
                className=""
                label={<span>Payment Source</span>}
                rules={[
                  {
                    required: true,
                    message: "Please select payment source",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    subwalletData?.length > 0 &&
                    subwalletData?.map((item) => ({
                      value: item?.walId,
                      label:
                      item?.walName +
                      " - " +
                      item?.walCode +
                      " - " +
                      item?.walCurrency +
                      " " +
                      item?.walAvailableBalance,
                    }))
                  }
                  notFoundContent={
                    <div
                      onClick={() => navigate("/my-wallet")}
                      className="cursor-pointer text-ndovuRed"
                    >
                      Assign wallet to this user
                    </div>
                  }
                  onChange={(value) => {
                    const selectedItem = subwalletData?.find(
                      (item) => item?.walId === value
                    );
                    dispatch(setSourceName(selectedItem?.walName || ""));
                    setPaymentSourceName(selectedItem?.walName || "");
                  }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                  onDropdownVisibleChange={() => {
                    fetchSubWalletData();
                  }}
                  dropdownRender={(menu) => (
                    <>
                      {dropLoading && (
                        <div
                          style={{
                            padding: "8px",
                            textAlign: "center",
                          }}
                        >
                          <Spin className="sms-spin" />
                        </div>
                      )}
                      {menu}
                    </>
                  )}
                />
              </Form.Item>

              <Form.Item
                name="pgPcId"
                className=""
                label={<span>Category</span>}
                rules={[
                  {
                    required: true,
                    message: "Please select payment category",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    dataCat?.length > 0 &&
                    dataCat?.map((item) => ({
                      value: item?.pcId,
                      label: item?.pcName,
                    }))
                  }
                  onChange={(value) => {
                    fetchSubCategoryData(value);
                    const selectedItem = dataCat?.find(
                      (item) => item?.pcId === value
                    );
                    setCategoryName(selectedItem?.pcName || "");
                    form.setFieldValue("pgPscId", undefined);
                    dispatch(
                      setActiveObj({
                        ...activeObj,
                        pgPcId: value,
                        pgPscId: undefined,
                      })
                    );
                  }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <div style={{ padding: 8 }}>
                        <Button
                          type="link"
                          onClick={() => setopenCategory(true)}
                          style={{ padding: 0 }}
                        >
                          + Add new Category
                        </Button>
                      </div>
                    </>
                  )}
                />
              </Form.Item>
              {pgPcId && (
                <Form.Item
                  name="pgPscId"
                  className=""
                  label={<span>Sub Category</span>}
                  rules={[
                    {
                      required: true,
                      message: "Please select payment sub-category",
                    },
                  ]}
                >
                  <Select
                    className=""
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    options={
                      dataSubCat?.length > 0 &&
                      dataSubCat?.map((item) => ({
                        value: item?.pscId,
                        label: item?.pscName,
                      }))
                    }
                    onChange={(value) => {
                      const selectedItem = dataSubCat?.find(
                        (item) => item?.pscId === value
                      );
                      setSubCategoryName(selectedItem?.pscName || "");
                    }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label?.toLocaleLowerCase() ?? "").includes(
                        input?.toLocaleLowerCase()
                      )
                    }
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <div style={{ padding: 8 }}>
                          <Button
                            type="link"
                            onClick={() => setopenSubCategory(true)}
                            style={{ padding: 0 }}
                          >
                            + Add new Sub-Category
                          </Button>
                        </div>
                      </>
                    )}
                  />
                </Form.Item>
              )}
            </div>
            <Form.Item
              name="pgReason"
              label="Reason for transfer"
              rules={[
                {
                  required: true,
                  message: "Enter reason for transfer",
                },
              ]}
            >
              <TextArea
                rows={4}
                placeholder="Enter reason for transfer"
                className="input-textarea"
              />
            </Form.Item>
          </div>
          <span className="paragraph mt-10 !text-[#3f4651]">
            Note: If you dont have an existing group, go to group setup page to
            create a group.
          </span>
        </div>

        <div className="bg-[rgba(31,45,61,0.03)] mt-8">
          <div className="py-7 w-full flex justify-end lg:px-10 px-3">
            <button
              disabled={authLoading}
              onClick={handleSubmitStep}
              type="button"
              className="cstm-btn-2  !w-[110px]"
            >
              {authLoading ? <Spin /> : "Next"} <img src={svg66} alt="svg66" />
            </button>
          </div>
        </div>
      </div>

      <CategoryAdd
        isModalOpen={openCategory}
        handleCancel={handleCancelCategory}
        handleFetch={fetchCategoryData}
        prodd=""
      />
      <SubCategoryAdd
        isModalOpen={openSubCategory}
        handleCancel={handleCancelSubCategory}
        handleFetch={() => fetchSubCategoryData(form.getFieldValue("pgPcId"))}
        prodd={form.getFieldValue("pgPcId") ? { pcId: form.getFieldValue("pgPcId") } : null}
      />
 
    </>
  );
}
